import { useState } from 'react';
import { CompanyForm } from '../../models/company.model';
import CompanyCreateForm from '../CompanyCreateForm';


interface CompanyCreateProps {
  setBlockScreen: (p: boolean) => void;
}

const CompanyCreate: React.FC<CompanyCreateProps> = ({ setBlockScreen }) => {

  const [companyForm, setCompanyForm] = useState<CompanyForm>({
    name: '',
    code: '',
    phone_number: '',
    description: '',
    created_date: '',
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setCompanyForm({
      ...companyForm,
      [event.target.name]: event.target.value
    });
  }

  return (
    <CompanyCreateForm
      companyForm={companyForm}
      setBlockScreen={setBlockScreen}
      handleChange={handleChange}
      action='create'
    />
  )
}

export default CompanyCreate;